import styled from 'styled-components';
import { mixins } from '../css';

const Container = styled.div`
  width: 100%;
  overflow-y: auto; // Fallback for non webkit browsers
  overflow-y: overlay;
`;

export default {
  Container
};
